<template>
  <div class="order-list">
    <el-row>
      <el-col :span="24">
        <div class="control-box">
          <div class="left">
            <div class="select-box">
              <el-input
                v-model="ordertableParams.workOrderId"
                :placeholder="$lange == 'en' ? 'Care ID' : '请输入服务号'"
                size="mini"
                style="width: 130px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-input
                v-model="ordertableParams.customerName"
                :placeholder="$lange == 'en' ? 'Customer' : '请输入客户'"
                size="mini"
                style="width: 130px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-input
                v-model="ordertableParams.jobId"
                placeholder="Job ID"
                size="mini"
                style="width: 130px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>

            <div class="select-box" style="width: 200px">
              <!--                            <el-input v-model="ordertableParams.handlerName" :placeholder="$lange == 'en' ? 'Responsible' : '处理人'" size="mini">-->
              <!--                                <i slot="prefix" class="el-input__icon el-icon-search"></i>-->
              <!--                            </el-input>-->
              <cc-selector
                :config="handlerSelectorConfig"
                style="width: 100%"
                :placeholder="$lange == 'en' ? 'Responsible' : '请选择处理人'"
                v-model="ordertableParams.handlerId"
              />
            </div>
            <div class="select-box">
              <el-select
                v-model="value"
                :placeholder="$lange == 'en' ? 'Status' : '请选择状态'"
                clearable
                size="mini"
                @change="orderStatusChange"
                style="width: 130px"
              >
                <el-option
                  v-for="item in orderStatusList"
                  :key="item.value"
                  :label="$lange == 'en' ? item.labelEn : item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="select-box">
              <el-input
                v-model="ordertableParams.title"
                size="mini"
                :placeholder="$lange == 'en' ? 'Subject' : '请输入问题标题'"
                style="width: 150px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-date-picker
                size="mini"
                v-model="seletcTime"
                type="datetimerange"
                range-separator="至"
                value-format="yyyy-MM-dd HH:mm:ss"
                :defaultTime="['00:00:00', '23:59:59']"
                :start-placeholder="$lange == 'en' ? 'StartTime' : '开始日期'"
                :end-placeholder="$lange == 'en' ? 'EndTime' : '结束日期'"
                @change="timeChange"
                style="width: 350px"
              >
              </el-date-picker>
            </div>
            <!--                        <el-button type="primary" size="mini">查询</el-button>-->
            <!-- <el-button type="primary" size="mini" @click="doSearch">{{
              $lange == "en" ? "Search" : "搜索"
            }}</el-button> -->
            <el-button type="primary" size="mini" @click="exportData">{{
              $lange == "en" ? "Export all" : "导出清单"
            }}</el-button>
            <el-button type="primary" size="mini" @click="createOrder">{{
              $lange == "en" ? "New Request" : "创建请求"
            }}</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="margin-top: 5px">
        <div class="table-box">
          <!--                    <div class="table-title flex-between">-->
          <!--                        <div class="left">-->
          <!--                            <div class="label">客户产品详情</div>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <div class="table-content">
            <cc-table
              :config="orderTableConfig"
              :params="ordertableParams"
              :refesh-params="referTable"
            ></cc-table>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- :title="$lange == 'en' ? 'Details' : '详情'" -->
    <el-dialog
      :visible.sync="detailsDialog"
      :fullscreen="true"
      :title="$lange == 'en' ? 'Details' : '详情'"
      @closed="dialogClose"
    >
      <template v-if="detailsDialog">
        <OrderDescriptionView
          :orderIdV2="detailsId"
          :isDialog="true"
        ></OrderDescriptionView>
        <!-- :isHandleV2="isHandleV2" -->
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import OrderDescriptionView from "./OrderDescription";
export default {
  name: "OrderList",
  components: {
    OrderDescriptionView,
  },
  data() {
    return {
      showDelete: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      orderStatusList: [
        // {
        //   value: "",
        //   label: "全部",
        // },
        // {
        //   label: "草稿",
        //   value: 0,
        // },
        // {
        //   label: "申请中",
        //   value: 1,
        // },
        // {
        //   label: "待客户确认",
        //   value: 2,
        // },
        // {
        //   label: "待审核",
        //   value: 3,
        // },
        // {
        //   label: "等待派工",
        //   value: 4,
        // },
        // {
        //   label: "服务中",
        //   value: 5,
        // },
        // {
        //   label: "已完成",
        //   value: 6,
        // },
        // {
        //   label: "已关闭",
        //   value: 7,
        // },
        // {
        //   label: "已取消",
        //   value: 8,
        // },

        {
          label: "申请中",
          value: 0,
          labelEn: "New",
        },
        {
          label: "处理中",
          value: 1,
          labelEn: "Processing",
        },
        {
          label: "观察中",
          value: 2,
          labelEn: "Monitoring",
        },
        {
          label: "已完成",
          value: 3,
          labelEn: "Completed",
        },
        {
          label: "已关闭",
          value: 4,
          labelEn: "Close",
        },
        {
          label: "已取消",
          value: 5,
          labelEn: "Cancelled",
        },
      ],
      handlerSelectorConfig: {
        api: "admin/fsb/work/order/queryHandlerIdList?pageSize=999&isAsc=true",
        isDisable: false,
        valProp: "id",
        labelProp: "name",
        valueType: "String",
      },
      referTable: -1,
      ordertableParams: {
        handlerId: "",
        workOrderId: "",
        customerName: "",
        jobId: "",
        handlerName: "",
        status: "",
        handleStatus: "",
        title: "",
        geCreateTime: "",
        leCreateTime: "",
      },
      value: "",
      detailsDialog: false,
      detailsId: "",
      isHandleV2: false,
      orderTableConfig: {
        api: "admin/fsb/work/order/query",
        showPager: true,
        // dragState: true,
        columns: [
          {
            prop: "id",
            lable: this.$lange == "en" ? "Care ID" : "服务号",
            minWidth: 70,
          },
          {
            prop: "jobId",
            lable: "Job ID",
            minWidth: 100,
          },
          {
            prop: "priority",
            lable: this.$lange == "en" ? "Priority" : "优先级",
            minWidth: 70,
            type: "constant",
            constantConfig: {
              code: "priority",
              api: "admin/dict/pageTree",
              // opts: { 0: "info", 1: "warning", 2: "success", 3: "danger" },
            },
          },
          {
            prop: "productStatus",
            lable: this.$lange == "en" ? "Product Stage" : "设备阶段",
            type: "constant",
            constantConfig: {
              code: "productStatus",
              api: "admin/dict/pageTree",
              opts: { 0: "info", 1: "warning", 2: "success", 3: "danger" },
            },
            minWidth: this.$lange == "en" ? 130 : 80,
          },
          {
            prop: "customer.customerName",
            lable: this.$lange == "en" ? "Customer" : "客户",
            minWidth: 100,
          },
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Contact" : "联系人",
            minWidth: 100,
          },
          {
            prop: "product",
            lable: this.$lange == "en" ? "Model" : "产线型号",
            render: (row) => {
              let res = "---";
              if (row.product) {
                res = row.product.productLine;
              }
              return res;
            },
          },
          {
            prop: "machine.machineType",
            lable: this.$lange == "en" ? "Machine" : "机器",
            type: "constant",
            constantConfig: {
              code: "machineType",
              api: "admin/dict/pageTree",
            },
          },
          {
            prop: "machine.fiCom",
            lable: this.$lange == "en" ? "COM" : "机器编号",
          },
          {
            prop: "title",
            lable: this.$lange == "en" ? "Subject" : "主题描述",
            minWidth: 160,
          },
          {
            prop: "handlerName",
            lable: this.$lange == "en" ? "Responsible" : "处理人",
            minWidth: 80,
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "请求状态",
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "New" : "申请中",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Processing" : "处理中",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Monitoring" : "观察中",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已完成",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Close" : "已关闭",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Cancelled" : "已取消",
              },
            ],
            // render: (row) => {
            //   let type = [
            //     {
            //       label: "申请中",
            //       value: 0,
            //     },
            //     {
            //       label: "处理中",
            //       value: 1,
            //     },
            //     {
            //       label: "观察中",
            //       value: 2,
            //     },
            //     {
            //       label: "已完成",
            //       value: 3,
            //     },
            //     {
            //       label: "已关闭",
            //       value: 4,
            //     },
            //     {
            //       label: "已取消",
            //       value: 5,
            //     },
            //   ];
            //   return type[row.status].label;
            // },

            minWidth: this.$lange == "en" ? 100 : 140,
          },
          {
            prop: "requestType",
            lable: this.$lange == "en" ? "Request Category" : "请求类型",
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Information Inquiry" : "一般咨询",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Spare Part Order" : "配件申请",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Machine Failures" : "问题故障",
              },
            ],
            minWidth: this.$lange == "en" ? 150 : 90,
          },

          {
            prop: "malfunctionAttribute.name",
            lable: this.$lange == "en" ? "Problem Category" : "故障分类",
            render: (row) => {
              if (row.malfunctionAttribute) {
                if (this.$lange == "en") {
                  return row.malfunctionAttribute.engName;
                }
                return row.malfunctionAttribute.name;
              }
            },
          },
          // {
          //   prop: "problemAttribute.name",
          //   lable: this.$lange == "en" ? "Issue Source" : "来源分析",
          //   render: (row) => {
          //     if (row.problemAttribute) {
          //       if (this.$lange == "en") {
          //         return row.problemAttribute.engName;
          //       }
          //       return row.problemAttribute.name;
          //     }
          //   },
          // },

          {
            prop: "updateTime",
            lable: this.$lange == "en" ? "Last update" : "更新时间",
            minWidth: 100,
            render: (row) => {
              return moment(row.updateTime).format("YYYY-MM-DD");
            },
          },
          // {
          //   prop: "createTime",
          //   lable: this.$lange == "en" ? "Created" : "创建时间",
          //   render: (row) => {
          //     return moment(row.createTime).format("YYYY-MM-DD");
          //   },
          //   minWidth: 100,
          // },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View" : "详情",
            click: (row) => {
              this.newWindow({
                url: "/admin/order/des?id=" + row.id,
                name: "服务请求详情",
              });
              // this.detailsId = row.id;
              // this.detailsDialog = true;
              // this.isHandleV2 = row.isHandle;
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "移除",
            check: (row) => {
              // if (row.status !== 5) {
              //   return true;
              // }
              if (this.showDelete) {
                return true;
              }
              return false;
            },
            click: (row) => {
              this.$confirm(
                "此操作会删除该工单及其相关的配件订单跟外派服务单, 是否确定?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                this.ccRequest
                  .do("admin/fsb/work/order/delete", { id: row.id }, "GET")
                  .then((res) => {
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                    this.referTable = new Date().getTime();
                  })
                  .catch((res) => {
                    this.$message({
                      type: "warning",
                      message: res.response.data.message,
                    });
                  });
              });
            },
          },
          {
            name: this.$lange == "en" ? "Handle" : "处理",
            check: (row) => {
              let res = true;
              if (row.isHandle === false) {
                res = false;
              }
              return res;
            },
            click: (row) => {
              this.$confirm("该操作是处理请求, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.newWindow({
                  url: "/admin/order/des?id=" + row.id,
                  name: "服务请求详情",
                });
                // this.detailsId = row.id;
                // this.detailsDialog = true;
                // this.isHandleV2 = row.isHandle;
              });
            },
          },
        ],
      },
      ordertableParams2: {
        handlerId: "",
        workOrderId: "",
        customerName: "",
        jobId: "",
        handlerName: "",
        status: "",
        handleStatus: "",
        title: "",
      },
      seletcTime: [],
    };
  },
  methods: {
    dialogClose() {
      console.log(this.isHandleV2);
      if (this.isHandleV2) {
        this.referTable = new Date().getTime();
      }
    },
    doSearch() {
      this.ordertableParams2 = { ...this.ordertableParams };
      if (this.seletcTime && this.seletcTime.length > 0) {
        this.ordertableParams2 = {
          ...this.ordertableParams2,
          geCreateTime: this.seletcTime[0],
          leCreateTime: this.seletcTime[1],
        };
      }
    },
    timeChange(e) {
      console.log(e);
      if (e) {
        this.ordertableParams.geCreateTime = e[0];
        this.ordertableParams.leCreateTime = e[1];
      } else {
        this.ordertableParams.geCreateTime = "";
        this.ordertableParams.leCreateTime = "";
      }
    },
    orderStatusChange(res) {
      console.log(res, "res");
      // let obj = {
      //   status: "",
      //   handleStatus: "",
      // };
      // if (res.indexOf("-") > -1) {
      //   let arr = res.split("-");
      //   obj.status = arr[0];
      //   obj.handleStatus = arr[1];
      // } else {
      //   obj.status = res;
      //   obj.handleStatus = "";
      // }
      // if (res === "all") {
      //   obj = {
      //     status: "",
      //     handleStatus: "",
      //   };
      // }
      // this.ordertableParams = {
      //   ...this.ordertableParams,
      //   ...obj,
      // };
      this.ordertableParams = {
        ...this.ordertableParams,
        status: res,
      };
    },
    exportData() {
      let text = "?appId=fosber";
      for (const key in this.ordertableParams) {
        if (
          this.ordertableParams[key] !== "" &&
          this.ordertableParams[key] !== undefined
        ) {
          text += "&" + key + "=" + this.ordertableParams[key];
        }
      }
      if (this.seletcTime.length > 0) {
        text +=
          "&geCreateTime=" +
          this.seletcTime[0] +
          "&leCreateTime=" +
          this.seletcTime[1];
      }
      window.open("/admin/fsb/work/order/workOrderExport" + text);
      // window.open(
      //   `${this.$apis.config.server}admin/fsb/work/order/workOrderExport?jobId=${this.ordertableParams.jobId}&handlerId=${this.ordertableParams.handlerId}&customerName=${this.ordertableParams.customerName}&status=${this.ordertableParams.status}&handleStatus=${this.ordertableParams.handleStatus}&title=${this.ordertableParams.title}`
      // );
    },
    createOrder() {
      this.$router.push({
        name: "OrderCreate",
      });
    },
  },
  mounted() {
    //權限查詢  勾選或超級管理員
    this.ccRequest
      .do(`validate`, { menuCode: "deleteWorkOrder" }, "GET")
      .then((res) => {
        this.showDelete = true;
      })
      .catch((err) => {});
    this.ccRequest
      .do(`validate`, {}, "GET")
      .then((res) => {
        if (res.roleTips == "administrator") {
          this.showDelete = true;
        }
      })
      .catch((err) => {});
  },
};
</script>
<style >
.order-list .el-dialog__body {
  padding: 10px 20px 30px 20px;
}
</style>
<style scoped lang="scss">
.control-box {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  background: #ffffff;

  .select-box {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
</style>
